import type { AssuranceVideo } from "@unbox/api";
import { formatCreatorId } from "@/utils/formatters";
import { buildTikTokVideoUrl } from "../utils";

export const FLAGGED_CSV_HEADERS = [
  "videoName",
  "videoId",
  "creatorHandle",
  "datePosted",
  "riskDetected",
  "videoLink",
] as const;

export const FLAGGED_CSV_PRETTY_HEADERS = [
  "Video name",
  "Video ID",
  "Creator handle",
  "Date posted",
  "Risk detected",
  "Video link",
];

export type FlaggedVideoCsvRow = {
  videoName: string;
  videoId: string;
  creatorHandle: string;
  datePosted: string;
  // Kept as an array so downloadCSV joins the risks into one cell ("Alcohol; Profanity").
  riskDetected: string[];
  videoLink: string;
};

export const toFlaggedVideoCsvRow = (v: AssuranceVideo): FlaggedVideoCsvRow => ({
  videoName: v.videoTitle ?? "",
  videoId: v.videoId.replace("VID-", ""),
  creatorHandle: v.creatorId ? formatCreatorId(v.creatorId) : "",
  // publishDate is a date-only column; take the string as-is rather than through a Date,
  // which would shift the day in negative-offset timezones.
  datePosted: v.publishDate.slice(0, 10),
  riskDetected: v.flagTypes ?? [],
  videoLink: buildTikTokVideoUrl(v.creatorId, v.videoId),
});
